import { isEmpty } from 'lodash';

export const isValidUserAction = (currentAction, dispatchedAction) =>
    currentAction.actionType === dispatchedAction.actionType && !isEmpty(dispatchedAction.status);
